<div class="modal-header">
	<h2>{{modalTitles[step-1]}}</h2>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<hr>
<div class="modal-body d-flex align-items-center" style="width: 100%; justify-content: center;">
	<!-- Step 1: Basic Contract Info -->
	<div id="basic-info" class="full-modal" *ngIf="step==1 && !loading">
		<form [formGroup]="basicContractInfo">
			<div class="row">
				<div class="col-6">
					<h3 class="labels">User</h3>
					<select id="userid" class="form-control" formControlName="userid" (change)="selectUser()"
                        [ngClass]="{'is-valid': basicContractInfo.get('userid')?.touched && validateField(basicContractInfo, 'userid'),
                                    'is-invalid': basicContractInfo.get('userid')?.touched && !validateField(basicContractInfo, 'userid')}">
						<option value="" disabled selected>Select User</option>
						<option *ngFor="let user of users" [value]="user.id">{{ user.first }} {{ user.last }}</option>
					</select>
				</div>
				<div class="col-6">
					<h3 class="labels">Industry</h3>
					<select id="industry" class="form-control" formControlName="industry"
                        [ngClass]="{'is-valid': basicContractInfo.get('industry')?.touched && validateField(basicContractInfo, 'industry'),
                                    'is-invalid': basicContractInfo.get('industry')?.touched && !validateField(basicContractInfo, 'industry')}">
						<option value="" disabled selected>Select Industry</option>
						<option *ngFor="let industry of industries" [value]="industry.id">{{ industry.description }}</option>
					</select>
				</div>

			</div>
			<br>
			<div class="row">
				<div class="col-6">
					<h3 class="labels">Periodicity</h3>
					<select id="period" class="form-control" formControlName="periodicity"
                        [ngClass]="{'is-valid': basicContractInfo.get('periodicity')?.touched && validateField(basicContractInfo, 'periodicity'),
                                    'is-invalid': basicContractInfo.get('periodicity')?.touched && !validateField(basicContractInfo, 'periodicity')}">
						<option value="" disabled selected>Select Period</option>
						<option *ngFor="let period of periods" [value]="period.value">{{ period.label }}</option>
					</select>
				</div>
				<div class="col-6">
					<h3 class="labels">Source</h3>
					<select id="source" class="form-control" formControlName="source"
						[ngClass]="{'is-valid': basicContractInfo.get('source')?.touched && validateField(basicContractInfo, 'source'),
									'is-invalid': basicContractInfo.get('source')?.touched && !validateField(basicContractInfo, 'source')}">
						<option value="" disabled selected>Select Source</option>
						<option *ngFor="let source of sources" [value]="source.name">{{ source.name }}</option>
					</select>
				</div>
			</div>
			<br>
			<div class="row">
				<div class="col-4">
					<h3 class="labels">Contract Types</h3>
					<div *ngFor="let type of contract_types" class="form-check">
						<input type="radio" class="form-check-input" [id]="'contract_type_' + type.id" [value]="type.id"
							formControlName="contract_type" (click)="updateSelectedContractType(type.id)"
							[ngClass]="{'is-invalid': !basicContractInfo.get('contract_type')?.value && basicContractInfo.get('contract_type')?.touched}" />
						<label class="form-check-label" [for]="'contract_type_' + type.id">{{ type.name }}</label>
					</div>
				</div>
				<div class="col-4" *ngIf="basicContractInfo.get('contract_type')?.value == 1">
					<h3 class="labels">Cost per Lead</h3>
					<input type="number" id="cost_lead" placeholder="Cost per Lead" class="form-control" formControlName="cost_lead"
						step="0.01" min="0"
						[ngClass]="{'is-valid': basicContractInfo.get('cost_lead')?.touched && validateField(basicContractInfo, 'cost_lead'),
									'is-invalid': basicContractInfo.get('cost_lead')?.touched && !validateField(basicContractInfo, 'cost_lead')}" />
				</div>
				<div class="col-4" *ngIf="basicContractInfo.get('contract_type')?.value == 2">
					<h3 class="labels">Reserve Leads amount</h3>
					<input type="number" id="reserve_amount" placeholder="Reserve Leads amount" class="form-control"
						formControlName="reserve_amount" min="0"
						[ngClass]="{'is-valid': basicContractInfo.get('reserve_amount')?.touched && validateField(basicContractInfo, 'reserve_amount'),
									'is-invalid': basicContractInfo.get('reserve_amount')?.touched && !validateField(basicContractInfo, 'reserve_amount')}" />

				</div>
				<div class="col-4" *ngIf="basicContractInfo.get('contract_type')?.value == 3">
					<h3 class="labels">Cost per hour</h3>
					<input type="number" id="cost_hour" placeholder="Cost per hour" class="form-control"
						formControlName="cost_hour" min="0"
						[ngClass]="{'is-valid': basicContractInfo.get('cost_hour')?.touched && validateField(basicContractInfo, 'cost_hour'),
									'is-invalid': basicContractInfo.get('cost_hour')?.touched && !validateField(basicContractInfo, 'cost_hour')}" />
				</div>

			</div>
		</form>
	</div>

	<!-- Step 2: Schedule Information -->
	<div id="schedule-info" class="full-modal" *ngIf="step==2 && !loading">
		<form [formGroup]="scheduleInfo">
			<div class="row">
				<div class="col-6">
					<h3 class="labels">Start Date</h3>
					<input type="date" id="start_date" class="form-control" formControlName="start_date"
                        [ngClass]="{'is-valid': scheduleInfo.get('start_date')?.touched && validateField(scheduleInfo, 'start_date'),
                                    'is-invalid': scheduleInfo.get('start_date')?.touched && !validateField(scheduleInfo, 'start_date')}" />
				</div>
				<div class="col-6">
					<h3 class="labels">End Date (Optional)</h3>
					<input type="date" id="end_date" class="form-control" formControlName="end_date" />
				</div>
			</div>
		</form>
	</div>



	<!-- Step 3: Additional Information -->
	<div id="additional-info" class="full-modal" *ngIf="step==3 && !loading">
		<form [formGroup]="additionalInfo">
			<div class="row">
				<div class="col-12">
					<h3 class="labels">Notes (Optional)</h3>
					<textarea id="notes" placeholder="Additional notes" class="form-control" formControlName="notes" rows="4"></textarea>
				</div>
			</div>
		</form>
	</div>

	<!-- Step 4: Contract Summary -->
	<div id="contract-summary" class="full-modal" *ngIf="step==4 && !loading">
		<div class="summary-container">
			<h3 class="summary-title">Contract Summary</h3>

			<div class="row mb-4">
				<div class="col-12">
					<div class="card">
						<div class="card-header bg-light">
							<h5 class="mb-0">Basic Information</h5>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-md-6">
									<p><strong>User:</strong> {{ getUserFullName(contract.userid) }}</p>
									<p><strong>Industry:</strong> {{ utils.getIndustryLabel(contract.industry) }}</p>
									<p><strong>Period:</strong> {{ getPeriodLabel(contract.periodicity) }}</p>
									<p><strong>Source:</strong> {{ getSourceLabel(contract.source) }}</p>
								</div>
								<div class="col-md-6">
									<p><strong>Contract Type:</strong> {{ getContractTypeName(contract.contract_type) }}</p>
									<p *ngIf="contract.contract_type == 1"><strong>Cost per Lead:</strong> ${{ contract.cost_lead }}</p>
									<p *ngIf="contract.contract_type == 2"><strong>Reserve Amount:</strong> {{ contract.reserve_amount }}</p>
									<p *ngIf="contract.contract_type == 3"y><strong>Cost per Hour:</strong> ${{ contract.cost_hour }}</p>
									<p><strong>Active:</strong> {{ contract.isActive ? 'Yes' : 'No' }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row mb-4">
				<div class="col-12">
					<div class="card">
						<div class="card-header bg-light">
							<h5 class="mb-0">Schedule Information</h5>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-md-6">
									<p><strong>Start Date:</strong> {{ contract.start_date | utcToLocal : 'mediumDate' }}</p>
								</div>
								<div class="col-md-6">
									<p><strong>End Date:</strong> {{ contract.end_date ? (contract.end_date | utcToLocal : 'mediumDate') : 'Not specified' }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="card">
						<div class="card-header bg-light">
							<h5 class="mb-0">Additional Information</h5>
						</div>
						<div class="card-body">
							<p><strong>Notes:</strong> {{ contract.notes || 'No notes added' }}</p>
							<p><strong>Creation Date:</strong> {{ contract.date_creation | utcToLocal : 'mediumDate' }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div id="Company" class="full-modal d-flex justify-content-center align-items-center" *ngIf="loading">
		<div align="center">
			<div class="spinner-border text-primary" role="status">
				<span class="sr-only">Creating new contract...</span>
			</div>
			<br>
			<h3 class="loader-text">Creating new contract...</h3>
		</div>
	</div>

</div>
<hr>
<div class="modal-footer">
	<div class="container">
		<div class="row">
			<div class="col-6" align="left">
				<button type="button" class="btn btn-outline-secondary waves-effect waves-light" (click)="prev()"
					*ngIf="step != 1"> <i class="bx bx-arrow-back"></i> Back</button>
			</div>
			<div class="col-6" align="right">
				<button type="button" class="btn btn-secondary waves-effect waves-light" (click)="next()"
					*ngIf="step != 4">Next</button>
				<button type="button" class="btn btn-secondary waves-effect waves-light" (click)="createContract()"
					*ngIf="step == 4">Create Contract</button>
			</div>
		</div>
	</div>
</div>
